/**
 * JSON 编辑器组件
 * 用于 JSON Schema、约束条件等 JSON 输入
 */

import React, { useState, useEffect } from 'react';
import { Input, Alert } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';

interface JsonEditorProps {
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  rows?: number;
  disabled?: boolean;
}

const JsonEditor: React.FC<JsonEditorProps> = ({
  value = '',
  onChange,
  placeholder = '输入 JSON 格式，例如：{"maxLength": 2000, "minLength": 100}',
  rows = 6,
  disabled = false,
}) => {
  const [error, setError] = useState<string | null>(null);
  const [isValid, setIsValid] = useState<boolean>(true);

  useEffect(() => {
    validateJson(value);
  }, [value]);

  const validateJson = (jsonString: string) => {
    if (!jsonString || jsonString.trim() === '') {
      setError(null);
      setIsValid(true);
      return;
    }

    try {
      JSON.parse(jsonString);
      setError(null);
      setIsValid(true);
    } catch (e: any) {
      setError(e.message || '无效的 JSON 格式');
      setIsValid(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newValue = e.target.value;
    onChange?.(newValue);
  };

  const formatJson = () => {
    if (!value || value.trim() === '') return;

    try {
      const parsed = JSON.parse(value);
      const formatted = JSON.stringify(parsed, null, 2);
      onChange?.(formatted);
    } catch (e) {
      // 格式化失败，不做处理
    }
  };

  return (
    <div>
      <Input.TextArea
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        rows={rows}
        disabled={disabled}
        style={{
          fontFamily: 'monospace',
          ...(isValid ? {} : { borderColor: '#ff4d4f' }),
        }}
      />
      {value && (
        <div style={{ marginTop: 8, display: 'flex', alignItems: 'center', gap: 8 }}>
          {isValid ? (
            <span style={{ color: '#52c41a', fontSize: 12 }}>
              <CheckCircleOutlined /> JSON 格式正确
            </span>
          ) : (
            <span style={{ color: '#ff4d4f', fontSize: 12 }}>
              <CloseCircleOutlined /> {error}
            </span>
          )}
          {!disabled && (
            <a onClick={formatJson} style={{ fontSize: 12 }}>
              格式化
            </a>
          )}
        </div>
      )}
    </div>
  );
};

export default JsonEditor;
